/**
 * The password rule under a new-password field (AUTH-15): each rule ticks as it is met. Pass the
 * rules from usePasswordRules, so the checklist is the rule the server applies.
 */

import type { PasswordRule } from "../../lib/passwordRules";

export function PasswordChecklist({ password, rules }: { password: string; rules: PasswordRule[] }) {
  return (
    <ul className="space-y-1 text-sm" aria-label="Password must have">
      {rules.map((rule) => {
        const ok = rule.test(password);
        return (
          <li key={rule.key} className={`flex items-center gap-2 ${ok ? "text-success" : "text-ink-muted"}`}>
            <span aria-hidden="true" className="inline-block w-4 text-center font-semibold">
              {ok ? "✓" : "•"}
            </span>
            <span>{rule.label}</span>
            <span className="sr-only">{ok ? "— done" : "— not yet"}</span>
          </li>
        );
      })}
    </ul>
  );
}
